import _ from 'lodash'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AnimatedCounter from '../AnimatedCounter'
import attributes from '../../settings/references.json'
import styles from './server-selector.scss'

class ServerSelector extends Component {
    constructor(props) {
        super(props)

        // State for whether the drop-down is open
        this.state = {
            open: false,
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside)
    }

    // On click events
    onClick(active, server) {
        // If active server is being clicked
        // we toggle the open state
        if (active) {
            this.toggleOpen()
        } else {
            // Non-active server was selected
            // change places!
            this.switchServer(server)
        }
    }

    handleClickOutside = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({ open: false })
        }
    }

    toggleOpen() {
        this.setState({ open: !this.state.open })
    }

    switchServer(server) {
        // If the server state is not open, or if the requested server
        // is already active server, do nothing
        if (!this.state.open || server.shortName === this.props.activeServer) return null

        // Update the active server
        this.props.setActiveServer(server.shortName)

        // Create the path & hash
        const pathname = window.location.pathname
        const search = window.location.search
        const hash = `#server:${server.shortName}`

        // Combine the path & hash
        const urlParameters = pathname + search + hash

        // Update the URL of the launcher
        window.location.replace(`${server.websiteUrl}${urlParameters}`)

        // Update the given token
        window.setToken()
    }

    renderServer(server, active = false) {
        // Check whether we should show the caret
        const showCaret = active ? <span className="fa fa-caret-down" /> : null

        // Render the list items
        return (
            <a
                role="button"
                tabIndex="0"
                onClick={() => this.onClick(active, server)}
                onKeyPress={() => this.onClick(active, server)}
                key={server.shortName}
            >
                <li>
                    <span className={styles.server_name}>{server.name}</span>
                    {showCaret}
                    <br />
                    {this.renderServerStatus(server)}
                    {this.renderPlayerCount(server)}
                </li>
            </a>
        )
    }

    renderOpenMenu() {
        // If the state isn't open, or servers are missing we render nothing
        if (!this.state.open || this.props.servers == null || _.isEmpty(this.props.servers)) {
            return null
        }

        // Get toggle options
        let servers = _.pick(this.props.servers, 'tq', this.props.testServers)

        // Omit the active server from the options in drop-down
        servers = _.omit(servers, this.props.activeServer)

        // Map the toggle options
        return _.map(servers, value => this.renderServer(value))
    }

    renderPlayerCount(server) {
        // If the server is disabled or shouldn't show players
        // just return null
        if (!server.enabled || !server.showPlayers) return null

        return (
            <AnimatedCounter
                count={server.numPlayers}
                showCounter={server.showPlayers}
                counterTextSingular={this.props.localize('player')}
                counterTextPlural={this.props.localize('players')}
                language={this.props.language}
            />
        )
    }

    renderServerStatus(server) {
        // If the server is disabled or shouldn't show players
        // just return null
        if (!server.enabled || !server.showPlayers) return null

        return (
            <span className={`${styles[server.status]} ${styles.status}`}>
                {this.props.localize(server.status)}
            </span>
        )
    }

    render() {
        // If servers are missing, render nothing
        if (this.props.servers == null || _.isEmpty(this.props.servers)) return null

        // Get the active server object
        const currentServer = this.props.servers[this.props.activeServer]

        // generate the necessary classes for open/closed drop-down
        const classes = this.state.open
            ? `${styles.server_selector} ${this.props.parentStyles} ${styles.open}`
            : `${styles.server_selector} ${this.props.parentStyles}`

        return (
            <ul className={classes} ref={ref => (this.wrapperRef = ref)}>
                {this.renderServer(currentServer, true)}
                {this.renderOpenMenu()}
                <li />
            </ul>
        )
    }
}

ServerSelector.propTypes = {
    activeServer: PropTypes.string,
    servers: PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.shape({
            enabled: PropTypes.bool,
            name: PropTypes.string,
            numPlayers: PropTypes.number,
            shortName: PropTypes.string,
            websiteUrl: PropTypes.string,
            status: PropTypes.string,
            statusLabel: PropTypes.string,
            showPlayers: PropTypes.bool,
        }),
    }),
    localize: PropTypes.func,
    testServers: PropTypes.arrayOf(PropTypes.string),
    setActiveServer: PropTypes.func,
    parentStyles: PropTypes.string,
    language: PropTypes.string,
}

ServerSelector.defaultProps = {
    activeServer: 'tq',
    servers: {
        tq: {
            enabled: true,
            name: 'Tranquility',
            numPlayers: 0,
            shortName: 'tq',
            websiteUrl: `https://launcher.${attributes.service.domains.production}/`,
            status: 'unknown',
            statusLabel: 'unknown',
            showPlayers: true,
        },
        sisi: {
            enabled: true,
            name: 'Singularity',
            numPlayers: 0,
            shortName: 'sisi',
            websiteUrl: `https://launcher.${attributes.service.domains.testing}/`,
            status: 'unknown',
            statusLabel: 'unknown',
            showPlayers: true,
        },
        duality: {
            enabled: true,
            name: 'Duality',
            numPlayers: 0,
            shortName: 'duality',
            websiteUrl: `https://launcher.${attributes.service.domains.testing}/`,
            status: 'unknown',
            statusLabel: 'unknown',
            showPlayers: true,
        },
        thunderdome: {
            enabled: true,
            name: 'Thunderdome',
            numPlayers: 0,
            shortName: 'thunderdome',
            websiteUrl: `https://launcher.${attributes.service.domains.testing}/`,
            status: 'unknown',
            statusLabel: 'unknown',
            showPlayers: true,
        },
    },
    testServers: [],
}

export default ServerSelector



// WEBPACK FOOTER //
// ./src/components/ServerSelector/server-selector.js